import { AisToggleRefinement } from 'vue-instantsearch'

export default {
  components: {
    AisToggleRefinement,
  },
  data() {
    return {
      toggleFilters: [
        { name: 'In Stock', value: 'in_stock' },
        { name: 'On Sale', value: 'on_sale' },
        { name: 'Ships Free', value: 'free_shipping' }
      ]
    }
  },
  methods: {
    getToggleFilterName ({ name }) {
      return name.toUpperCase()
    }
  }
}